import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Header } from './Header';

@Injectable({
  providedIn: 'root'
})
export class HeaderNavService {

  private option = new BehaviorSubject<Header>({ name:'intro', icon: 'inp-icon-flows-o'});
  public customOption = this.option.asObservable();
  constructor() {}

  /** Valor actual del título (otras pantallas pueden haberlo pisado). */
  public snapshot(): Header {
    return this.option.getValue();
  }

  /**
   * Actualiza el título del header. Siempre difiere un macrotask: si corre en el
   * mismo turno de CD que HeaderNav (click del sidebar, AfterViewInit, etc.),
   * el flip de `@if (header?.visible)` dispara NG0100.
   */
  public changeOption(option: Header): void {
    setTimeout(() => this.option.next(option), 0);
  }
}
